import React, {useEffect} from "react";
import {FC} from "react";
import toast, {Toaster, useToasterStore} from "react-hot-toast";
import {useDispatch, useSelector} from "react-redux";
import {AppStateType} from "../../redux/reducers";
import {removeToasts} from "../../redux/actions/errorsActions";
import InfoIcon from '@mui/icons-material/Info';

const TOAST_LIMIT = 3;

const ToastProvider:FC<any> = ({children}) => {
  const toastsList = useSelector((state: AppStateType) => state.errorsReducer.toasts);
  const dispatch = useDispatch()
  const { toasts } = useToasterStore();

  useEffect(() => {
    if (toastsList.length > 0) {
      toastsList.forEach(({message, method, type}) => {
        switch (type) {
          case 'success':
            toast.success(`${message}`)
            break
          case 'error':
            toast.error(`${method.toUpperCase()}: ${message}`)
            break
          case 'info':
            toast(`${message}`, {
              icon: <InfoIcon style={{color: 'rgb(144, 202, 249)'}}/>
            })
            break
          default:
            toast.success(`${message}`)
            break
        }
      })
      dispatch(removeToasts())
    }
  }, [toastsList])

  // Enforce Limit
  useEffect(() => {
    toasts
      .filter((t) => t.visible) // Only consider visible toasts
      .filter((_, i) => i >= TOAST_LIMIT) // Is toast index over limit
      .forEach((t) => toast.dismiss(t.id)); // Dismiss – Use toast.remove(t.id) removal without animation
  }, [toasts]);

  return (
    <React.Fragment>
      {children}
      <Toaster
        position="bottom-right"
        gutter={8}
        toastOptions={{
          // Define default options
          className: '',
          duration: 7000,
          style: {
            background: '#233044',
            color: '#fff',
          }
        }}
      />
    </React.Fragment>
  )
}

export default ToastProvider